export enum IntermediariesColumnSizes {
  Name = 23,
  Type = 8,
  IdNumber = 9,
  Phone = 12,
  Email = 16,
  CreatedAt = 16,
  UpdatedAt = 16,
}
